import UploadFiles, {
  UploadFilesProps,
} from "components/uploader/UploadFiles/";
import {
  CreateAssetResponse,
  CreateMediaAssetRequest,
  MediaAsset,
} from "../media/types";
import { GetOneResponse } from "@refinedev/core";

export const AssetUploader = ({
  uploadProps,
  onUploadComplete,
}: {
  uploadProps: UploadFilesProps;
  onUploadComplete: (assets: Partial<MediaAsset>[]) => void;
}) => {
  return (
    <UploadFiles
      {...uploadProps}
      maxFileSize={120}
      onUploadComplete={(files, responses) => {
        // Insert the newly created asset into the list for immediate
        // usage without waiting for the backend to process it
        const itemRequestProperties = uploadProps.itemRequestProperties;
        const stagedItems = uploadProps.stagedItems;
        const newAssets = responses.map((response, index) => {
          if (typeof itemRequestProperties !== "function") return;
          const file = files[index];
          const { asset, category, source, description } =
            itemRequestProperties(
              file?.originFileObj
            ) as CreateMediaAssetRequest;
          const staged = stagedItems?.find((item) => item.uid === file?.uid);

          const newAsset: Partial<MediaAsset> = {
            id: (response as GetOneResponse<CreateAssetResponse>).data.asset_id,
            category,
            source,
            description: staged?.description ?? description,
            tags: staged?.tags,
            asset_type: asset.type,
            path: URL.createObjectURL(file?.originFileObj as Blob),
          };
          return newAsset;
        });
        onUploadComplete?.(newAssets);
      }}
    />
  );
};
